<template>
  <div>
    <div>
      <strong>Rates</strong>
    </div>
    <p>The drop is (start) $3.40 + the miles $2.85 waiting time is 25 per hour</p>

    <div class="mt-10">
      <strong>Ride Rate</strong>
    </div>
    <p>Distance: {{ estimation.distance }} miles</p>
    <p>Rate: ${{ estimation.rate }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'GreenPointEstimation',

  props: {
    estimation: {
      type: Object,
      required: true,
    },
  },
};
</script>
